import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'

import { Toast  } from 'vant';
import axios from 'axios';
import Utils from './utils.js';
import App from './App'

Vue.use(Router)
Vue.use(Vuex)
Vue.filter('moneyFormat2', function(value) {
  return Utils.formatMoney(value, 2);
})

Vue.config.productionTip = false
window.Utils = Utils;

var originalId = Utils.getQueryString("originalId") || "";
const service = axios.create({
  baseURL: "", //process.env.BASE_URL,  // api的base_url
  timeout: 5000  // 请求超时时间
});
/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
  // app.$vux.loading.show({
  //     text: '数据加载中……'
  // });
  let defaultParams = {
    // originalId: originalId
  };
  // 默认值与接口传来的参数进行合并（注：接口参数与默认值不可重复）
  config.params = Object.assign(defaultParams, config.params);
  // config.method === 'post'
  //     ? config.data = qs.stringify({...config.data})
  //     : config.params = {...config.params};
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

  return config;
}, error => {  //请求错误处理
  // app.$vux.toast.show({
  //     type: 'warn',
  //     text: error
  // });
  Promise.reject(error)
});

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (!res.success) {
      //此处进行异常处理
      return Promise.reject(res);
    } else {
      return response.data;
    }
  },
  error => {
    //此处进行异常处理
    return Promise.reject(error)
  }
);


Vue.prototype.$utils = Utils;
Vue.prototype.toast = Toast;
Vue.prototype.$http = service;
var __MARKET__ = {
  0:"货币B",
  1:"沪深A",
  2:"指数I",
  3:"产品F",
  4:"港股H",
  9:"另类O"
}
Vue.prototype.market = function (itype) {
  return __MARKET__[itype]||"未知";
}
let promise = null;
if (promise == null) {
  promise = new Promise(function (resolve) {
    resolve({})
  })
}
promise.then(() => {
  let router = new Router({
    mode: 'history'
  })
  router.addRoutes([{
    path: '/pc/stocks/',
    component: r => require.ensure([], () => r(require('@/components/StockWatching.vue')), 'StockWatching'),
    name: 'StockWatchingDefault'
  }, {
    path: '/pc/stocks/:zqdm',
    component: r => require.ensure([], () => r(require('@/components/StockWatching.vue')), 'StockWatching'),
    name: 'StockWatching'
  }]);
  router.push = (location, onComplete, onAbort) => {
    if (!location.query) {
      location.query = {};
    } 
    // if (!location.query.originalId) {
    //   location.query.originalId = originalId;
    // }
    Router.prototype.push.call(router, location, onComplete, onAbort);
  };
  // router.beforeEach((to, from, next) => {
  //   if (!to.query.originalId) {
  //     to.query.originalId = originalId;
  //   }
  //   next()
  // });
  // window.console.log(cust);
  var store = new Vuex.Store({
    state: {
    }
  })
  Vuex.mapState({})
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
